export interface CheckCollectionOrderBookNumberRequest {
  id: number
  inputs: {
    holdingBranchCode: string
    number: number
    traderCode: string
    donorCode: string
    acceptType: string
    buyDepartmentCode: string
    budgetYear: number
    budgetBranchCode: string
    budgetDepartmentCode: string
    budgetExpenseCode: string
    equipType: string
    collectionType: string
    appendixCode: string
  }[]
}

export function CheckCollectionOrderBookNumberRequestToJSON(
  value: CheckCollectionOrderBookNumberRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    inputs: value.inputs.map(input => {
      return {
        holding_branch_code:
          input.holdingBranchCode !== '' ? input.holdingBranchCode : undefined,
        number: input.number ? input.number : undefined,
        trader_code: input.traderCode !== '' ? input.traderCode : undefined,
        donor_code: input.donorCode !== '' ? input.donorCode : undefined,
        accept_type: input.acceptType !== '' ? input.acceptType : undefined,
        buy_department_code:
          input.buyDepartmentCode !== '' ? input.buyDepartmentCode : undefined,
        budget_year: input.budgetYear ? input.budgetYear : undefined,
        budget_branch_code:
          input.budgetBranchCode !== '' ? input.budgetBranchCode : undefined,
        budget_department_code:
          input.budgetDepartmentCode !== ''
            ? input.budgetDepartmentCode
            : undefined,
        budget_expense_code:
          input.budgetExpenseCode !== '' ? input.budgetExpenseCode : undefined,
        equip_type: input.equipType !== '' ? input.equipType : undefined,
        collection_type:
          input.collectionType !== '' ? input.collectionType : undefined,
        appendix_code:
          input.appendixCode !== '' ? input.appendixCode : undefined
      }
    })
  }
}
